import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import AOS from 'aos/dist/aos.js';
import { Fancybox } from "@fancyapps/ui";

const navigator = document.querySelector("nav");
const navbtn = document.querySelector('.nav-btn');
const close = document.querySelector(".close-menu"); 
const out = document.querySelector("main");

navbtn.addEventListener("click", function(){
    navigator.classList.add('show');
});

close.addEventListener("click", function(){
    navigator.classList.remove('show');
});

out.addEventListener("click", function(){
    navigator.classList.remove('show');
});


document.addEventListener("DOMContentLoaded", function() {
    const selectElement = document.getElementById("categorySelect");
    if (selectElement) {
        selectElement.addEventListener("change", function() {
            const value = this.value;
            if (value) {
                location.href = value;
            }
        });
    }

    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });
});

$ = jQuery;

$(".slider").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false
});

AOS.init({
    once: true,
});

$('.slider').on('afterChange', function(event, slick, currentSlide) {
    AOS.refresh();
});

$('#categorySelect').dropkick();

document.addEventListener('DOMContentLoaded', () => {
    const select = document.getElementById('categorySelect2');
    const items = document.querySelectorAll('.item');
    const resetButton = document.querySelector('input[type="reset"]');

    const choices = new Choices(select, {
        removeItemButton: true,
        placeholder: true,
        placeholderValue: 'Seleccione una categoría',
        searchPlaceholderValue: 'Buscar categorías',
        noResultsText: 'No se encontraron resultados',
        noChoicesText: 'No hay opciones para elegir',
        itemSelectText: 'Presione para seleccionar',
        uniqueItemText: 'Sólo se pueden agregar valores únicos',
        customAddItemText: 'Solo se pueden agregar valores que coincidan con condiciones específicas',
    });

    const urlParams = new URLSearchParams(window.location.search);
    const urlCategory = urlParams.get('category');

    if (urlCategory) {
        const categoryOption = Array.from(select.options).find(option => option.text.toLowerCase() === urlCategory.toLowerCase());
        if (categoryOption) {
            categoryOption.selected = true;
            choices.setChoiceByValue(categoryOption.value);
        }
    }



    const filterItems = () => {
        const selectedValues = Array.from(select.selectedOptions).map(option => option.value);
        
        items.forEach(item => {
            const itemCategories = item.getAttribute('data-category').split(' ');
            const showItem = selectedValues.length === 0 || selectedValues.some(value => itemCategories.includes(value));
            item.style.display = showItem ? 'flex' : 'none';
        });

        resetButton.style.display = selectedValues.length > 0 ? 'inline-block' : 'none';
    };

    // Reiniciar el select y mostrar todos los items al hacer clic en reset
    resetButton.addEventListener('click', () => {
        choices.removeActiveItems(); // Reinicia las selecciones del select
        items.forEach(item => {
            item.style.display = 'flex'; // Muestra todos los items
        });
        resetButton.style.display = 'none'; // Oculta el botón reset
    });


    filterItems();

    select.addEventListener('change', filterItems);
});




$('#mall-select').dropkick();


$(function(){
    // bind change event to select
    $('#mall-select').on('change', function () {
        let url = $(this).val(); // get selected value
        if (url) { // require a URL
            window.location = url; // redirect
        }
        return false;
    });
});